import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const ServiceCenterIcon = React.forwardRef((props, ref) => (
  <SvgIcon data-qe-id="ServiceCenterIcon" {...props} ref={ref}>
    <>
      <path d="M11.4 1.02C6.62 1.33 3 5.51 3 10.31V20h6v-8H5v-1.71C5 6.45 7.96 3.11 11.79 3 15.76 2.89 19 6.06 19 10v2h-4v8h4v1h-7v2h9V10c0-5.17-4.36-9.32-9.6-8.98z" />
    </>
  </SvgIcon>
));

export default ServiceCenterIcon;
